'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const faqItems = [
  {
    question: 'Which is the best Vadhu Var Suchak for Kolhapur?',
    answer: 'MarathiVadhuVarSuchak.com is the best option for Bhairavnath Vadhu Var Suchak Mandal. Here you can find profiles from Kagal Kolhapur, like a Bhairavnath Vadhu Var Suchak Kendra.'
  },
  {
    question: 'Which is the best Vadhu Var for Kolhapur Kadamwadi profiles?',
    answer: 'MarathiVadhuVarSuchak.com is the best option for Tararani Vadhu Var Suchak Mandal to search profiles of Kolhapur-based Maratha Vadhu Var.'
  },
  {
    question: 'For Marathi marriage, which is the best site?',
    answer: 'MarathiVadhuVarSuchak.com is the trusted Maratha Matrimony. You can check Maratha Matrimony Reviews on the official site. So, do not wait and do Maratha Matrimony Login for free signup.'
  },
  {
    question: 'For Maratha Vivah, which is the trusted site?',
    answer: 'MarathiVadhuVarSuchak.com is the trusted Maratha Vivah Sanstha. For Maratha Vivah login, visit the site or install the Maratha Vivah App. This is the best Maratha Vivah Matrimony. You can search the Maratha Vivah photos with the profile here. For Maratha Vivah WhatsApp number check the contact page. You can find Maratha Vivah Pune city-based profiles too.'
  },
  {
    question: 'Which is the best Maratha Vadhu Var Suchak in Mumbai?',
    answer: 'In Mumbai city, MarathiVadhuVarSuchak.com matrimony is the trusted platform to search maratha Vadhu Var Suchak photos with a profile.'
  },
  {
    question: 'How to search the Lagnatharle photos with a profile?',
    answer: 'Use the Lagnatharle login app navigation of \'MarathiVadhuVarSuchak.com\' to search Lagnatharle photos with a profile.'
  },
  {
    question: 'Which is the best Brahmin Maratha Matrimony in Maharashtra?',
    answer: 'For Marathi Brahmin grooms and brides, the MarathiVadhuVarSuchak.com matrimony is the best option in Maharashtra state.'
  },
];

export default function LagnatharleVadhuVarSuchakClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="सुशिक्षित मराठी वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="lagnatharle_vadhu_var_suchak"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">
            Saptaphere and Saptapadi importance in Marathi Marriage <br />Sacred Wedding Rituals
            </h2>
            <p className="text-gray-700 leading-relaxed" style={{ fontSize: '1.11rem' }}>
            In a traditional Marathi marriage, the sacred rituals of Saptaphere and Saptapadi hold the deepest spiritual and cultural significance, binding two souls in a lifelong bond. Saptaphere, the seven rounds taken around the holy fire (agni), symbolize the couple's shared promises of love, loyalty, prosperity, and togetherness. Saptapadi, the seven sacred steps walked together, represent the seven divine vows that form the very foundation of a blissful Marathi wedding. These timeless Vedic rituals are an inseparable part of every Maharashtrian Hindu vivah vidhi, passed down through generations with deep reverence. At MarathiVadhuVarSuchak.com, we celebrate these sacred traditions by helping you find a life partner who shares your values, culture, and family customs. Begin your journey of Saptaphere and Saptapadi with the right Marathi Vadhu or var - register free today.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
